import { cloneDeep, isNil } from "lodash";
import store from "../../stores";
import { userType } from "../../const/nuclias/user";

const expandChildren = (selectedTag) => {
  return new Promise((Resolve, reject) => {
    const storeObj = {};
    const storeTagObj = {};
    let childProfileList = [];
    const insertStore = (stores, parentTagId) => {
      for (const store of stores) {
        const tmpStore = cloneDeep(store);
        tmpStore.parentStoreTagId = parentTagId;
        storeObj[tmpStore.id] = tmpStore;
        childProfileList = childProfileList.concat(store.deviceGroups);
      }
    };

    const insertStoreTag = (tags, parentTagId) => {
      for (const tag of tags) {
        const tmpTag = cloneDeep(tag);
        insertStoreTag(tag.storeTags, tag.id);
        insertStore(tag.stores, tag.id);

        tmpTag.parentStoreTagId = parentTagId;
        storeTagObj[tmpTag.id] = tmpTag;
        childProfileList = childProfileList.concat(tag.deviceGroups);
      }
    };
    insertStoreTag(selectedTag.storeTags, null);
    insertStore(selectedTag.stores, null);

    Resolve({ storeTagObj, storeObj, childProfileList });
  });
};

export const expandSiteAndTag = async (orgObj) => {
  return new Promise(async (Resolve, reject) => {
    if (isNil(orgObj.selectedOrg)) {
      Resolve(orgObj); return;
    }
    const { storeTagObj, storeObj, childProfileList } = await expandChildren(orgObj.selectedOrg);
    orgObj.selectedOrg.storeTagObj = storeTagObj;
    orgObj.selectedOrg.storeObj = storeObj;
    orgObj.selectedOrg.deviceGroups = orgObj.selectedOrg.deviceGroups.concat(childProfileList);
    Resolve(orgObj);
  });
};

export const initSelectedTagSite = (orgObj) => {
  return new Promise(async (Resolve, reject) => {
    const user = store.getState().user.user;
    if ((user.type !== userType.siteTag && user.type !== userType.site) || isNil(orgObj.selectedOrg)) {
      Resolve(orgObj); return;
    }

    const id = user.manageResources[0].id;
    if (user.type === userType.siteTag) {
      const selectedTag = orgObj.selectedOrg.storeTagObj[id];
      const { storeTagObj, storeObj } = await expandChildren(selectedTag);
      selectedTag.storeTagObj = storeTagObj;
      selectedTag.storeObj = storeObj;
      orgObj.selectedStoreTag = selectedTag;
    } else {
      orgObj.selectedStore = orgObj.selectedOrg.storeObj[id];
    }
    Resolve(orgObj);
  });
};

export const initOrgTreeMap = (orgObj) => {
  return new Promise(async (Resolve, reject) => {
    const user = store.getState().user.user;
    const flag = { isStorePrivilege: false, isTagPrivilege: false, tagPrivilegeId: null };

    if (user.type === userType.site) {
      flag.isStorePrivilege = true;
    }
    if (user.type === userType.siteTag) {
      flag.isTagPrivilege = true;
      flag.tagPrivilegeId = user.manageResources[0].id;
    }

    if (flag.isStorePrivilege || isNil(orgObj.selectedOrg)) {
      Resolve(orgObj); return;
    }

    const getReverseTags = () => {
      const tmp = [];
      for (const [tagId, tagItem] of Object.entries(orgObj.selectedOrg.storeTagObj)) {
        tmp.push(tagItem.id);
      }
      return tmp.reverse();
    };

    const reverseTags = getReverseTags();
    const result = {};
    result.withStore = await getWithStoreTags(flag, orgObj.selectedOrg, reverseTags);
    result.withoutStore = await getWithoutStoreTags(flag, orgObj.selectedOrg, reverseTags, result.withStore);
    orgObj.orgTreeMap = result;

    Resolve(orgObj);
  });
};

export const getWithStoreTags = (flag, selectedOrg, reverseTags) => {
  return new Promise(async (Resolve, Reject) => {
    const storeTagObj = selectedOrg.storeTagObj;

    const map = {};
    for (const [storeId, storeItem] of Object.entries(selectedOrg.storeObj)) {
      map[storeId] = [];
      let indexKey = null;
      if (!isNil(storeItem.parentStoreTagId)) {
        indexKey = storeItem.parentStoreTagId;
        map[storeId].push(storeTagObj[storeItem.parentStoreTagId].id);
      }
      for (const tagId of reverseTags) {
        const storeTag = storeTagObj[tagId];
        if (storeTag.id === indexKey && !isNil(storeTag.parentStoreTagId)) {
          if (flag.isTagPrivilege && storeTag.id === flag.tagPrivilegeId) { continue; }
          indexKey = storeTag.parentStoreTagId;
          map[storeId].push(storeTagObj[indexKey].id);
        }
      }
    }
    Resolve(map);
  });
};

export const getWithoutStoreTags = (flag, selectedOrg, reverseTags, withStore) => {
  return new Promise(async (Resolve, reject) => {
    const storeTagObj = selectedOrg.storeTagObj;
    const findRelateStoreTag = (unfiledTags) => {
      const map = {};
      let mapIndex = 0;
      for (const indexTagId of unfiledTags) {
        if (storeTagObj[indexTagId].storeTags.length > 0) { continue; }
        map[mapIndex] = [storeTagObj[indexTagId].id];
        let indexKey = indexTagId;

        for (const reverseTagId of reverseTags) {
          const storeTag = storeTagObj[reverseTagId];
          if (storeTag.id === indexKey && !isNil(storeTag.parentStoreTagId)) {
            if (flag.isTagPrivilege && storeTag.id === flag.tagPrivilegeId) { continue; }
            indexKey = storeTag.parentStoreTagId;
            map[mapIndex].push(storeTagObj[storeTag.parentStoreTagId].id);
          }
        }
        mapIndex++;
      }
      return map;
    };

    const tmp = [];
    for (const [tagId, tagItem] of Object.entries(selectedOrg.storeTagObj)) {
      let hasSite = false;
      for (const [siteId, tags] of Object.entries(withStore)) {
        if (tags.indexOf(tagItem.id) !== -1) {
          hasSite = true;
          break;
        }
      }
      if (!hasSite) { tmp.push(tagItem.id); }
    }

    let result = {};
    if (tmp.length) { result = findRelateStoreTag(tmp); }
    Resolve(result);
  });
};

export const expandDevice = (orgObj) => {
  return new Promise(async (Resolve, reject) => {
    if (isNil(orgObj.selectedOrg)) {
      Resolve(orgObj); return;
    }

    const deviceGroupObj = {};
    for (const deviceGroup of orgObj.selectedOrg.deviceGroups) {
      if (!deviceGroup.isInventory) {
        deviceGroupObj[deviceGroup.id] = deviceGroup;
      }
    }

    const deviceObj = {};
    for (const device of orgObj.selectedOrg.devices) {
      deviceObj[device.id] = device;
    }
    orgObj.selectedOrg.deviceGroupObj = deviceGroupObj;
    orgObj.selectedOrg.deviceObj = deviceObj;
    Resolve(orgObj);
  });
};